"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = __importDefault(require("../data/Base"));
var Users = /** @class */ (function (_super) {
    __extends(Users, _super);
    function Users(id) {
        var _this = _super.call(this, id) || this;
        _this.path = function () {
            return "/users/" + _this.id;
        };
        _this.getIdsForUser = function (uid) {
            throw new Error("not implemented");
        };
        _this.getConfig = function (orgId) {
            throw new Error("not implemented");
        };
        _this.getSettings = function () {
            return _this.getByPath(_this.path());
        };
        _this.updateInfo = function (user) {
            return _this.update(_this.path(), user);
        };
        _this.getConnections = function (orgId, uid) {
            return _this.getByPath("/presence/" + orgId + "/users/" + uid + "/connections");
        };
        _this.getLastOnlineTimes = function (orgId, uid) {
            return _this.getByPath("/presence/" + orgId + "/users/" + uid + "/lastOnline");
        };
        _this.getDotInfoConnected = function () {
            return _this.getByPath(".info/connected");
        };
        _this.getPresenceUsers = function (orgId) {
            return _this.getByPath("/presence/" + orgId + "/users");
        };
        return _this;
    }
    return Users;
}(Base_1.default));
exports.default = Users;
//# sourceMappingURL=Users.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/Users.js
// module id = 618
// module chunks = 8